import { render, staticRenderFns } from "./ziInvestmentParter.vue?vue&type=template&id=3afeab0e&scoped=true&"
import script from "./ziInvestmentParter.vue?vue&type=script&lang=js&"
export * from "./ziInvestmentParter.vue?vue&type=script&lang=js&"
import style0 from "./ziInvestmentParter.vue?vue&type=style&index=0&id=3afeab0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afeab0e",
  null
  
)

export default component.exports